import PropTypes from 'prop-types';
import { styled } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NkDialogTransition from '../nkDialogTransition';
import { NkConfirmDialogProps } from './nkConfirmDialog.types';

export const NkConfirmDialog = (props: NkConfirmDialogProps) => {
  return (
    <div>
      <Dialog
        open={props.isOpen}
        onClose={props.onNo}
        TransitionComponent={NkDialogTransition}
      >
        <StyledDialogTitle id="alert-dialog-title">
          {props.message}
        </StyledDialogTitle>
        <DialogContent>
          {/* @ts-ignore TS doesn't recognize the 'component' prop */}
          <StyledDialogContent component="span" id="alert-dialog-description">
            {props.subMessage}
          </StyledDialogContent>
          <br />
          {props.isLoading && <LinearProgress />}
        </DialogContent>
        <DialogActions>
          <Button
            disabled={props.isLoading}
            onClick={props.onYes}
            variant="outlined"
            color="primary"
            startIcon={<FontAwesomeIcon icon={faCheckCircle} />}
            autoFocus
          >
            {props.confirmLabel}
          </Button>
          <Button
            disabled={props.isLoading}
            onClick={props.onNo}
            variant="outlined"
            color="primary"
            startIcon={<FontAwesomeIcon icon={faTimesCircle} />}
          >
            {props.cancelLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.customProps.header.backgroundColor,
  color: theme.palette.text.primary,
  textTransform: 'uppercase',
}));

const StyledDialogContent = styled(DialogContentText)(({ theme }) => ({
  color: theme.palette.text.main,
  fontFamily: theme.typography.fontFamily,
  lineHeight: theme.typography.body1.lineHeight,
  fontWeight: 300,
}));

NkConfirmDialog.propTypes = {
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.node,
  subMessage: PropTypes.node,
  isLoading: PropTypes.bool,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
};
